'use strict';

var AppState = require('app_state');
var Cookie = require('utils/cookie');
var i18n = require('utils/i18n');
var Requests = require('utils/requests');

var Messages = {};

Messages.getInfo = function (id) {
    var defer = $.Deferred();

    Requests.firstURLfromList(
        Requests.getMetaInfoURLs(i18n.language, id),
        function (data) {
            defer.resolve(data);
        },
        function () {
            defer.resolve(false);
        }
    );

    return defer.promise();
};

Messages.initialize = function () {
    var language = Cookie.get('language', navigator.language || navigator.userLanguage);
    language = language.substring(0, 2);

    var defer = $.Deferred();

    var setMessagesMetaInfo = function (data) {
        AppState.version = data.app_version;
        AppState.message = data.message;

        defer.resolve(true);
    };

    Requests.firstURLfromList(Requests.getMetaInfoURLs(language, 'meta'), setMessagesMetaInfo, function () {
        defer.resolve(false);
    });

    return defer.promise();
};

module.exports = Messages;
